<template>
  <div>
    <!-- 访问 -->
    <div class="container section">
      <div class="section-chart-title">
        访问概况
        <div class="section-chart-op">
          <el-date-picker v-model="dateDailySummary" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          <span
            class="date-shortcut"
            v-bind:class="{ active: isActiveDailySummary === 7 }"
            v-on:click="
              () => {
                dateDailySummary = [yesterday().add(-7, 'days'), yesterday()];
                isActiveDailySummary = 7;
              }
            "
            >最近7天</span
          >
          <span
            class="date-shortcut"
            v-bind:class="{ active: isActiveDailySummary === 30 }"
            v-on:click="
              () => {
                dateDailySummary = [yesterday().add(-30, 'days'), yesterday()];
                isActiveDailySummary = 30;
              }
            "
            >最近30天</span
          >
        </div>
      </div>

      <div class="chart-main">
        <ve-line height="360px" :colors="['#FF0000', '#FF7F00', '#FFFF00']" :data="chartDataDailySummary" :legend="{ left: 0, bottom: 0 }"></ve-line>
      </div>
    </div>
    <!-- 页面 -->
    <div class="container section">
      <div class="section-chart-title">
        访问页面
        <div class="section-chart-op">
          <el-date-picker v-model="dateVisitPage" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          <span
            class="date-shortcut"
            v-bind:class="{ active: isActiveVisitPage === 7 }"
            v-on:click="
              () => {
                dateVisitPage = [yesterday().add(-7, 'days'), yesterday()];
                isActiveVisitPage = 7;
              }
            "
            >最近7天</span
          >
          <span
            class="date-shortcut"
            v-bind:class="{ active: isActiveVisitPage === 30 }"
            v-on:click="
              () => {
                dateVisitPage = [yesterday().add(-30, 'days'), yesterday()];
                isActiveVisitPage = 30;
              }
            "
            >最近30天</span
          >
        </div>
      </div>
      <div>
        <el-table :data="tableDataVisitPage">
          <el-table-column prop="pagepath" label="页面"></el-table-column>
          <el-table-column prop="pagevisitpv" label="访问次数"></el-table-column>
          <el-table-column prop="pagevisituv" label="访问人数"></el-table-column>
          <el-table-column prop="pagestaytimepv" label="次均停留时长(秒)"></el-table-column>
          <el-table-column prop="entrypagepv" label="进入页面次数"></el-table-column>
          <el-table-column prop="exitpagepv" label="退出页面次数"></el-table-column>
          <el-table-column prop="pagesharepv" label="转发次数"></el-table-column>
          <el-table-column prop="pageshareuv" label="转发人数"></el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 来源 -->
    <div class="container section">
      <div class="section-chart-title">
        访问来源
        <div class="section-chart-op">
          <el-date-picker v-model="dateVisitSource" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          <span
            class="date-shortcut"
            v-bind:class="{ active: isAcitveVisitSource === 7 }"
            v-on:click="
              () => {
                dateVisitSource = [yesterday().add(-7, 'days'), yesterday()];
                isAcitveVisitSource = 7;
              }
            "
            >最近7天</span
          >
          <span
            class="date-shortcut"
            v-bind:class="{ active: isAcitveVisitSource === 30 }"
            v-on:click="
              () => {
                dateVisitSource = [yesterday().add(-30, 'days'), yesterday()];
                isAcitveVisitSource = 30;
              }
            "
            >最近30天</span
          >
        </div>
      </div>
      <div>
        <el-table :data="tableDataVisitSource">
          <el-table-column prop="source" label="来源"></el-table-column>
          <el-table-column prop="pv" label="页面访问次数"></el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 时长 -->
    <div class="container section">
      <div class="section-chart-title">
        访问时长
        <div class="section-chart-op">
          <el-date-picker v-model="dateVisitStaytime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          <span
            class="date-shortcut"
            v-bind:class="{ active: isAcitveVisitStaytime === 7 }"
            v-on:click="
              () => {
                dateVisitStaytime = [yesterday().add(-7, 'days'), yesterday()];
                isAcitveVisitStaytime = 7;
              }
            "
            >最近7天</span
          >
          <span
            class="date-shortcut"
            v-bind:class="{ active: isAcitveVisitStaytime === 30 }"
            v-on:click="
              () => {
                dateVisitStaytime = [yesterday().add(-30, 'days'), yesterday()];
                isAcitveVisitStaytime = 30;
              }
            "
            >最近30天</span
          >
        </div>
      </div>
      <div>
        <el-table :data="tableDataVisitStaytime">
          <el-table-column prop="staytime" label="访问时长"></el-table-column>
          <el-table-column prop="pv" label="页面访问次数"></el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 深度 -->
    <div class="container section">
      <div class="section-chart-title">
        访问深度
        <div class="section-chart-op">
          <el-date-picker v-model="dateVisitDepth" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          <span
            class="date-shortcut"
            v-bind:class="{ active: isAcitveVisitDepth === 7 }"
            v-on:click="
              () => {
                dateVisitDepth = [yesterday().add(-7, 'days'), yesterday()];
                isAcitveVisitDepth = 7;
              }
            "
            >最近7天</span
          >
          <span
            class="date-shortcut"
            v-bind:class="{ active: isAcitveVisitDepth === 30 }"
            v-on:click="
              () => {
                dateVisitDepth = [yesterday().add(-30, 'days'), yesterday()];
                isAcitveVisitDepth = 30;
              }
            "
            >最近30天</span
          >
        </div>
      </div>
      <div>
        <el-table :data="tableDataVisitDepth">
          <el-table-column prop="depth" label="访问深度"></el-table-column>
          <el-table-column prop="pv" label="页面访问次数"></el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 趋势 -->
    <div class="container section">
      <div class="section-chart-title">
        小程序趋势
        <div class="section-chart-op">
          <el-date-picker v-model="dateVisitTrend" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          <span
            class="date-shortcut"
            v-bind:class="{ active: isAcitveVisitTrend === 7 }"
            v-on:click="
              () => {
                dateVisitTrend = [yesterday().add(-7, 'days'), yesterday()];
                isAcitveVisitTrend = 7;
              }
            "
            >最近7天</span
          >
          <span
            class="date-shortcut"
            v-bind:class="{ active: isAcitveVisitTrend === 30 }"
            v-on:click="
              () => {
                dateVisitTrend = [yesterday().add(-30, 'days'), yesterday()];
                isAcitveVisitTrend = 30;
              }
            "
            >最近30天</span
          >
        </div>
      </div>

      <div class="chart-main">
        <ve-line height="360px" :colors="['#FF0000', '#FF7F00', '#FFFF00', '#00FF00', '#00FFFF', '#0000FF', '#8B00FF']" :data="chartDataVisitTrend" :legend="{ left: 0, bottom: 0 }"></ve-line>
      </div>
    </div>
    <!-- 留存 -->
    <div class="container section">
      <div class="section-chart-title">
        <el-dropdown @command="chooseRetainKind">
          <span style="font-size: 20px; font-weight: 500; color: #000;" class="el-dropdown-link"> {{ visitRetainKind === 1 ? '新增用户留存' : '活跃用户留存' }}<i class="el-icon-arrow-down el-icon--right"></i> </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="1">新增用户留存</el-dropdown-item>
            <el-dropdown-item :command="2">活跃用户留存</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="section-chart-op">
          <el-date-picker v-model="dateVisitRetain" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          <span
            class="date-shortcut"
            v-bind:class="{ active: isAcitveVisitRetain === 7 }"
            v-on:click="
              () => {
                dateVisitRetain = [yesterday().add(-7, 'days'), yesterday()];
                isAcitveVisitRetain = 7;
              }
            "
            >最近7天</span
          >
          <span
            class="date-shortcut"
            v-bind:class="{ active: isAcitveVisitRetain === 30 }"
            v-on:click="
              () => {
                dateVisitRetain = [yesterday().add(-30, 'days'), yesterday()];
                isAcitveVisitRetain = 30;
              }
            "
            >最近30天</span
          >
        </div>
      </div>
      <div>
        <el-table :data="visitRetainKind === 1 ? tableDataVisitRetainNew : tableDataVisitRetain">
          <el-table-column :width="(visitRetainKind === 1 ? tableDataVisitRetainNew : tableDataVisitRetain).length ? (index === 0 ? '100px' : 'auto') : 'auto'" v-for="(item, index) in visitRetainKind === 1 ? tableControlVisitRetainNew : tableControlVisitRetain" :key="index" :prop="item.prop" :label="item.label"></el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 用户画像 -->
    <div class="container section">
      <div class="section-chart-title">
        <el-dropdown @command="chooseUserPortraitKind">
          <span style="font-size: 20px; font-weight: 500; color: #000;" class="el-dropdown-link"> {{ userPortraitKind === 1 ? '新增用户画像' : '活跃用户画像' }}<i class="el-icon-arrow-down el-icon--right"></i> </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="1">新增用户画像</el-dropdown-item>
            <el-dropdown-item :command="2">活跃用户画像</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="section-chart-op">
          <span class="date-shortcut" v-bind:class="{ active: userPortraitDateKind === 1 }" @click="userPortraitDateKind = 1">昨天</span>
          <span class="date-shortcut" v-bind:class="{ active: userPortraitDateKind === 2 }" @click="userPortraitDateKind = 2">最近7天</span>
          <span class="date-shortcut" v-bind:class="{ active: userPortraitDateKind === 3 }" @click="userPortraitDateKind = 3">最近30天</span>
        </div>
      </div>
      <div>
        <el-row gutter="30">
          <el-col span="12">
            <el-table border max-height="266" :data="userPortraitKind === 1 ? dataUserPortraitProvinceNew : dataUserPortraitProvince">
              <el-table-column prop="name" label="省份"></el-table-column>
              <el-table-column prop="value" label="用户数"></el-table-column>
            </el-table>
          </el-col>
          <el-col span="12">
            <el-table border max-height="266" :data="userPortraitKind === 1 ? dataUserPortraitCityNew : dataUserPortraitCity">
              <el-table-column prop="name" label="城市"></el-table-column>
              <el-table-column prop="value" label="用户数"></el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <el-row gutter="30" style="margin-top: 30px;">
          <el-col span="12">
            <ve-line height="360px" :colors="['#FF0000', '#FF7F00']" :data="userPortraitKind === 1 ? dataUserPortraitAgesNew : dataUserPortraitAges" :legend="{ left: 0, bottom: 0 }"></ve-line>
          </el-col>
          <el-col span="12">
            <ve-histogram height="360px" :colors="['#FF7F00']" :data="userPortraitKind === 1 ? dataUserPortraitGendersNew : dataUserPortraitGenders" :legend="{ left: 0, bottom: 0 }"></ve-histogram>
          </el-col>
        </el-row>

        <el-row gutter="30" style="margin-top: 30px;">
          <el-col span="12">
            <el-table style="margin-top: 56px;" border max-height="266" :data="userPortraitKind === 1 ? dataUserPortraitDevicesNew : dataUserPortraitDevices">
              <el-table-column prop="name" label="设备"></el-table-column>
              <el-table-column prop="value" label="用户数"></el-table-column>
            </el-table>
          </el-col>
          <el-col span="12">
            <ve-histogram height="360px" :colors="['#FF7F00']" :data="userPortraitKind === 1 ? dataUserPortraitPlatformsNew : dataUserPortraitPlatforms" :legend="{ left: 0, bottom: 0 }"></ve-histogram>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { M } from '../../../service/grpc.js';
import { rpc } from '../../../service/index.js';
import { getToken } from '../../../service/helper.js';
import VeLine from 'v-charts/lib/line.common';
import VeBar from 'v-charts/lib/bar.common';
import VePie from 'v-charts/lib/pie.common';
import VeHistogram from 'v-charts/lib/histogram.common';
import moment from 'moment';

const yesterday = () => {
  const temp = moment(new Date()).add(-1, 'days');
  return moment([temp.year(), temp.month(), temp.date()]);
};

export default {
  components: {
    VeLine,
    VeBar,
    VePie,
    VeHistogram
  },
  data() {
    return {
      yesterday,

      dateDailySummary: [yesterday().add(-7, 'days'), yesterday()],
      isActiveDailySummary: 7,
      chartDataDailySummary: {
        columns: ['日期', '累计用户数', '转发人数', '转发次数'],
        rows: []
      },

      dateVisitPage: [yesterday().add(-7, 'days'), yesterday()],
      isActiveVisitPage: 7,
      tableDataVisitPage: [],

      dateVisitSource: [yesterday().add(-7, 'days'), yesterday()],
      isAcitveVisitSource: 7,
      tableDataVisitSource: [],

      dateVisitStaytime: [yesterday().add(-7, 'days'), yesterday()],
      isAcitveVisitStaytime: 7,
      tableDataVisitStaytime: [],

      dateVisitDepth: [yesterday().add(-7, 'days'), yesterday()],
      isAcitveVisitDepth: 7,
      tableDataVisitDepth: [],

      dateVisitTrend: [yesterday().add(-7, 'days'), yesterday()],
      isAcitveVisitTrend: 7,
      chartDataVisitTrend: {
        columns: ['日期', '打开次数', '页面访问次数', '访问人数', '新用户数', '人均停留时长(秒)', '次均停留时长(秒)', '平均访问深度'],
        rows: []
      },

      dateVisitRetain: [yesterday().add(-7, 'days'), yesterday()],
      isAcitveVisitRetain: 7,
      tableDataVisitRetain: [],
      tableDataVisitRetainNew: [],
      tableControlVisitRetain: [],
      tableControlVisitRetainNew: [],
      visitRetainKind: 1,

      userPortraitKind: 1,
      userPortraitDateKind: 3,

      dataUserPortraitAges: {
        columns: ['年龄', '用户数'],
        rows: []
      },
      dataUserPortraitPlatforms: {
        columns: ['终端', '用户数'],
        rows: []
      },
      dataUserPortraitGenders: {
        columns: ['性别', '用户数'],
        rows: []
      },
      dataUserPortraitCity: [],
      dataUserPortraitDevices: [],
      dataUserPortraitProvince: [],

      dataUserPortraitAgesNew: {
        columns: ['年龄', '用户数'],
        rows: []
      },
      dataUserPortraitPlatformsNew: {
        columns: ['终端', '用户数'],
        rows: []
      },
      dataUserPortraitGendersNew: {
        columns: ['性别', '用户数'],
        rows: []
      },
      dataUserPortraitCityNew: [],
      dataUserPortraitDevicesNew: [],
      dataUserPortraitProvinceNew: []
    };
  },
  created() {
    this.token = getToken();

    this.dailySummary();
    this.visitPage();
    this.visitRetain();
    this.visitTrend();
    this.visitDepth();
    this.visitStaytime();
    this.visitSource();
    this.userPortrait();
  },
  watch: {
    dateDailySummary() {
      this.dailySummary();
    },
    dateVisitPage() {
      this.visitPage();
    },
    dateVisitSource() {
      this.visitSource();
    },
    dateVisitStaytime() {
      this.visitStaytime();
    },
    dateVisitDepth() {
      this.visitDepth();
    },
    dateVisitTrend() {
      this.visitTrend();
    },
    dateVisitRetain() {
      this.visitRetain();
    },
    userPortraitDateKind() {
      this.userPortrait();
    }
  },
  methods: {
    chooseUserPortraitKind(c) {
      this.userPortraitKind = c;
    },
    chooseRetainKind(c) {
      this.visitRetainKind = c;
    },
    copy(v) {
      return JSON.parse(JSON.stringify(v));
    },
    formatDate(str) {
      return `${str.slice(0, 4)}-${str.slice(4, 6)}-${str.slice(6, 8)}`;
    },
    userPortrait() {
      rpc(
        'StoreAnalysisService.GetAnalysisUserPortrait',
        M('AnalysisUserPortraitKind', {
          token: M('Token', { token: this.token }),
          kind: this.userPortraitDateKind
        })
      ).then(res => {
        const dataUserPortrait = JSON.parse(res.jsonstring).visit_uv;
        const dataUserPortraitNew = JSON.parse(res.jsonstring).visit_uv_new;

        this.dataUserPortraitProvinceNew = dataUserPortraitNew.province;
        this.dataUserPortraitCityNew = dataUserPortraitNew.city;
        this.dataUserPortraitDevicesNew = dataUserPortraitNew.devices;
        this.dataUserPortraitAgesNew.rows = dataUserPortraitNew.ages.map(v => ({ 年龄: v.name, 用户数: v.value }));
        this.dataUserPortraitGendersNew.rows = dataUserPortraitNew.genders.map(v => ({ 性别: v.name, 用户数: v.value }));
        this.dataUserPortraitPlatformsNew.rows = dataUserPortraitNew.platforms.map(v => ({ 终端: v.name, 用户数: v.value }));

        this.dataUserPortraitProvince = dataUserPortrait.province;
        this.dataUserPortraitCity = dataUserPortrait.city;
        this.dataUserPortraitDevices = dataUserPortrait.devices;
        this.dataUserPortraitAges.rows = dataUserPortrait.ages.map(v => ({ 年龄: v.name, 用户数: v.value }));
        this.dataUserPortraitGenders.rows = dataUserPortrait.genders.map(v => ({ 性别: v.name, 用户数: v.value }));
        this.dataUserPortraitPlatforms.rows = dataUserPortrait.platforms.map(v => ({ 终端: v.name, 用户数: v.value }));
      });
    },
    visitRetain() {
      const begin = moment(this.dateVisitRetain[0]);
      const end = moment(this.dateVisitRetain[1]);

      rpc(
        'StoreAnalysisService.GetAnalysisVisitRetainList',
        M('AnalysisTime', {
          token: M('Token', { token: this.token }),
          createdatgreaterthan: begin.add(1, 'days').unix(),
          createdatlessthan: end.add(2, 'days').unix()
        })
      ).then(res => {
        const tableDataVisitRetain = res.analysisvisitretainlistList
          .map(item => {
            item.visituv = JSON.parse(item.visituvjsonstring).sort((a, b) => a.key > b.key);
            item.visituvnew = JSON.parse(item.visituvnewjsonstring).sort((a, b) => a.key > b.key);
            item.refdate = this.formatDate(item.refdate);
            return item;
          })
          .sort((a, b) => a.refdate > b.refdate);

        this.tableControlVisitRetain = [{ label: '日期', prop: 'refdate' }].concat(
          tableDataVisitRetain.map((item, index) => {
            if (index === 0) {
              return { label: '活跃用户数', prop: `${index}` };
            } else {
              return { label: `${index}日后`, prop: `${index}` };
            }
          })
        );

        this.tableControlVisitRetainNew = [{ label: '日期', prop: 'refdate' }].concat(
          tableDataVisitRetain.map((item, index) => {
            if (index === 0) {
              return { label: '新增用户数', prop: `${index}` };
            } else {
              return { label: `${index}日后`, prop: `${index}` };
            }
          })
        );

        this.tableDataVisitRetain = this.copy(tableDataVisitRetain).map(item => {
          for (let i = 0; i < tableDataVisitRetain.length; i += 1) {
            if (i === 0) {
              item[i] = item.visituv[i] ? item.visituv[i].value : 0;
            } else {
              const v = item.visituv[0] ? item.visituv[0].value : 0;
              const v1 = item.visituv[i] ? item.visituv[i].value : 0;
              const v2 = (v1 / v) * 100;
              item[i] = v2 ? `${v2.toFixed(2)}%` : '0%';
            }
          }
          return item;
        });

        this.tableDataVisitRetainNew = this.copy(tableDataVisitRetain).map(item => {
          for (let i = 0; i < tableDataVisitRetain.length; i += 1) {
            if (i === 0) {
              item[i] = item.visituvnew[i] ? item.visituvnew[i].value : 0;
            } else {
              const v = item.visituvnew[0] ? item.visituvnew[0].value : 0;
              const v1 = item.visituvnew[i] ? item.visituvnew[i].value : 0;
              const v2 = (v1 / v) * 100;
              item[i] = v2 ? `${v2.toFixed(2)}%` : '0%';
            }
          }
          return item;
        });
      });
    },
    visitTrend() {
      const begin = moment(this.dateVisitTrend[0]);
      const end = moment(this.dateVisitTrend[1]);

      rpc(
        'StoreAnalysisService.GetAnalysisVisitTrendList',
        M('AnalysisTime', {
          token: M('Token', { token: this.token }),
          createdatgreaterthan: begin.unix(),
          createdatlessthan: end.add(2, 'days').unix()
        })
      ).then(res => {
        let rows0 = res.analysisvisittrendlistList.map(v => ({
          日期: this.formatDate(v.refdate),
          打开次数: v.sessioncnt,
          页面访问次数: v.visitpv,
          访问人数: v.visituv,
          新用户数: v.visituvnew,
          '人均停留时长(秒)': v.staytimeuv,
          '次均停留时长(秒)': v.staytimesession,
          平均访问深度: v.visitdepth
        }));

        let rows = [];

        for (let b = begin; b.isBefore(end); b.add(1, 'days')) {
          rows.push(
            rows0.find(v => v['日期'] == b.format('YYYY-MM-DD')) || {
              日期: b.format('YYYY-MM-DD'),
              打开次数: 0,
              页面访问次数: 0,
              访问人数: 0,
              新用户数: 0,
              '人均停留时长(秒)': 0,
              '次均停留时长(秒)': 0,
              平均访问页面深度: 0
            }
          );
        }

        rows.pop();

        this.chartDataVisitTrend.rows = rows;
      });
    },
    visitDepth() {
      const begin = moment(this.dateVisitDepth[0]);
      const end = moment(this.dateVisitDepth[1]);

      rpc(
        'StoreAnalysisService.GetAnalysisVisitDepthList',
        M('AnalysisTime', {
          token: M('Token', { token: this.token }),
          createdatgreaterthan: begin.unix(),
          createdatlessthan: end.add(2, 'days').unix()
        })
      ).then(res => {
        this.tableDataVisitDepth = res.analysisvisitdepthlistList;
      });
    },
    visitStaytime() {
      const begin = moment(this.dateVisitStaytime[0]);
      const end = moment(this.dateVisitStaytime[1]);

      rpc(
        'StoreAnalysisService.GetAnalysisVisitStaytimeList',
        M('AnalysisTime', {
          token: M('Token', { token: this.token }),
          createdatgreaterthan: begin.unix(),
          createdatlessthan: end.add(2, 'days').unix()
        })
      ).then(res => {
        this.tableDataVisitStaytime = res.analysisvisitstaytimelistList;
      });
    },
    visitSource() {
      const begin = moment(this.dateVisitSource[0]);
      const end = moment(this.dateVisitSource[1]);

      rpc(
        'StoreAnalysisService.GetAnalysisVisitSourceList',
        M('AnalysisTime', {
          token: M('Token', { token: this.token }),
          createdatgreaterthan: begin.unix(),
          createdatlessthan: end.add(2, 'days').unix()
        })
      ).then(res => {
        this.tableDataVisitSource = res.analysisvisitsourcelistList;
      });
    },
    visitPage() {
      const begin = moment(this.dateVisitPage[0]);
      const end = moment(this.dateVisitPage[1]);

      rpc(
        'StoreAnalysisService.GetAnalysisVisitPageList',
        M('AnalysisTime', {
          token: M('Token', { token: this.token }),
          createdatgreaterthan: begin.unix(),
          createdatlessthan: end.add(2, 'days').unix()
        })
      ).then(res => {
        this.tableDataVisitPage = res.analysisvisitpagelistList;
      });
    },
    dailySummary() {
      const begin = moment(this.dateDailySummary[0]);
      const end = moment(this.dateDailySummary[1]);
      rpc(
        'StoreAnalysisService.GetAnalysisDailySummaryList',
        M('AnalysisTime', {
          token: M('Token', { token: this.token }),
          createdatgreaterthan: begin.unix(),
          createdatlessthan: end.add(2, 'days').unix()
        })
      ).then(res => {
        let rows0 = res.analysisdailysummarylistList.map(v => ({
          日期: this.formatDate(v.refdate),
          累计用户数: v.visittotal,
          转发人数: v.shareuv,
          转发次数: v.sharepv
        }));

        let rows = [];

        for (let b = begin; b.isBefore(end); b.add(1, 'days')) {
          rows.push(
            rows0.find(v => v['日期'] == b.format('YYYY-MM-DD')) || {
              日期: b.format('YYYY-MM-DD'),
              累计用户数: 0,
              转发人数: 0,
              转发次数: 0
            }
          );
        }

        rows.pop();

        this.chartDataDailySummary.rows = rows;
      });
    }
  }
};
</script>

<style>
.section {
  padding-left: 24px;
}
.section-two-col {
  display: flex;
}
.section-left {
  flex: 1;
  padding-right: 24px;
}
.section-right {
  min-width: 300px;
  margin-top: 60px;
}
.seciont-right-title {
  font-size: 18px;
  color: #666;
  line-height: 2.225;
  margin-bottom: 12px;
}
.unit {
  font-size: 16px;
  font-weight: normal;
  margin: 0 6px;
  color: #666;
  line-height: 1.375;
}
.date-shortcut {
  display: inline-block;
  font-size: 14px;
  font-weight: normal;
  border: 1px solid #dcdfe6;
  color: #c0c4cc;
  line-height: 38px;
  height: 40px;
  padding: 0 16px;
  box-sizing: border-box;
  border-radius: 4px;
  margin-left: 12px;
  cursor: pointer;
}
.date-shortcut.active {
  color: #ff4f4f;
  border: 1px solid #ff4f4f;
}

.section-title-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 12px 0 24px;
  font-size: 24px;
  color: #333;
  font-weight: 500;
}
.section-primary {
  display: flex;
  padding-bottom: 24px;
  border-bottom: 1px solid #efefef;
  margin-bottom: 24px;
}

.section-item {
  min-width: 180px;
}
.section-item-label {
  font-size: 17px;
  color: #999;
}
.section-item-digit {
  font-size: 28px;
  font-weight: 500;
  line-height: 1;
  margin-top: 20px;
  color: #333;
  display: flex;
  align-items: flex-end;
}

.section-chart-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 12px;
}

.section-chart-op {
  display: flex;
}

.section-secondary {
  display: flex;
}
.section-secondary .section-item-digit {
  font-size: 22px;
  margin-bottom: 20px;
}

.chart-gender {
  font-size: 0;
}

.chart-gender-item {
  float: left;
  display: inline-block;
  height: 24px;
  position: relative;
}
.chart-gender-item::after {
  content: ' ';
  position: absolute;
  top: 0;
  right: 2px;
  left: 0;
  bottom: 0;
  border-radius: 2px;
}
.chart-gender-item span {
  position: absolute;
  bottom: -18px;
  color: #666;
  left: 0;
  font-size: 12px;
  min-width: 48px;
}

.chart-gender-item.man::after {
  background-color: #037fff;
}
.chart-gender-item.unknown::after {
  background-color: #cccccc;
}
.chart-gender-item.woman::after {
  background-color: #ff4f4f;
}
.chart-gender-item.woman span {
  right: 0;
  left: auto;
}
</style>
